import { Component } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { LanguageServiceService } from '../../services/language-service.service';

@Component({
  selector: 'app-notuserheader-m',
  templateUrl: './notuserheader.m.component.html',
  styleUrl: './notuserheader.m.component.scss'
})
export class NotuserheaderMComponent {
  currentLanguage!: string | null;
  languageDropdownOpen = false;
  constructor(
    private transloco: TranslocoService,
    private _languageService: LanguageServiceService,

  ) {
    const savedLang = localStorage.getItem('language') || 'en';
    this.currentLanguage = savedLang;
    this.transloco.setActiveLang(this.currentLanguage);
  }
  toggleLanguage() {
    this._languageService.toggleLanguage();
    this.currentLanguage = localStorage.getItem('language') || 'en';
    this.transloco.setActiveLang(this.currentLanguage);
  }

  toggleLanguageDropdown(event?: Event): void {
    event?.stopPropagation();
    this.languageDropdownOpen = !this.languageDropdownOpen;
  }

  setLanguage(language: string, event?: Event): void {
    event?.stopPropagation();
    this._languageService.changeLanguage(language);
    this.currentLanguage = language;
    this.transloco.setActiveLang(language);
    this.languageDropdownOpen = false;
  }
}
